import React, { useContext } from 'react'

import SimpleLink from '../../../components/Simple/SimpleLink'

import { Routes } from '../../../configs/RouteConfig'
import UserContext from '../../../helper/userContext'

const InvoiceNumberRenderer = (props) => {
  const { value } = props

  const { currentLanguage } = useContext(UserContext)

  return (
    <SimpleLink
      to={'/' + currentLanguage + Routes.invoice + '/' + value}
      style={{ fontSize: 'inherit' }}
    >
      {value}
    </SimpleLink>
  )
}

export default InvoiceNumberRenderer
